import '@babel/polyfill'

/* ========================================================

   ** Browser Normalizer **

   This file is responsible for normalizing the browser environment before
   the application starts. Doing this allows us to safely use modern language
   features even when the end user is running an older browser.

   The following polyfills are included by default:

   1) Object.assign
   2) Promise

   ====================================================== */

// 1) Object.assign
// ------------------------------------
// We can't rely on Object.assign being a function since it may be buggy, so
// defer to `object-assign`. If our Object.assign implementation is correct
// (determined by `object-assign` internally) the polyfill will be discarded
// and the native implementation used.

if (!Object.assign) {
  Object.assign = require('object-assign')
}


// 2) Promise
// ------------------------------------
if (!window.Promise) {
  require('promise/lib/rejection-tracking').enable()
  window.Promise = require('promise/lib/es6-extensions.js')
}
if (window.Promise && !window.Promise.prototype.finally) {
  window.Promise.prototype.finally = function(callback) {
    return this.then(
      value => this.constructor.resolve(callback()).then(() => value),
      reason => this.constructor.resolve(callback()).then(() => { throw reason })
    )
  }
}
// 3) forEach on NodeList: https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function(callback, thisArg) {
    thisArg = thisArg || window
    for (let i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this)
    }
  }
}

if (!String.prototype.padStart) {
  String.prototype.padStart = function padStart(targetLength, padString) {
    targetLength = targetLength >> 0 //floor if number or convert non-number to 0;
    padString = String(padString || ' ')

    if (this.length > targetLength) {
      return String(this)
    } else {
      targetLength = targetLength - this.length

      if (targetLength > padString.length) {
        padString += padString.repeat(targetLength / padString.length)
      }
      return padString.slice(0, targetLength) + String(this)
    }
  }
}



// WEBPACK FOOTER //
// ./lib/polyfills.js